import React from 'react';
import { useGlobalState } from '../../stateProvider/StateProvider';
import Input from '../../forms/Input';
import FormSetting from '../../layout/FormSetting';
import { QuestRoute } from '../../api/QuestRoutes';
import PageBreak from '../../layout/PageBreak';
import HamQuest from '../../api/HamQuestGiver';
import { Regex } from '../../utility/regex';
import EmailInput from '../../forms/formComponents/EmailInput';

const Details = ({ ...props }) => {
    const {
        getUserData
    } = useGlobalState();

    return (
        <PageBreak>
            <FormSetting
                label='Change Password'
                inputs={{
                    currentPassword: '',
                    newPassword: ''
                }}
                onSubmit={e => HamQuest.post(QuestRoute.settings.resetPassword, e)}
                text='Update'
            >
                {({ values }) => (
                    <>
                        <Input
                            label='Password'
                            name='currentPassword'
                            type='password'
                            required
                        />
                        <Input
                            label='New Password'
                            name='newPassword'
                            type='password'
                            validate={Regex.test.password}
                            required
                        />
                        <Input
                            label='Confirm Password'
                            name='confirmPass'
                            type='password'
                            confirmation='newPassword'
                            required
                        />
                    </>
                )}
            </FormSetting>

            <FormSetting
                label={`User's Name`}
                getInputs={QuestRoute.roles}
                onSubmit={e => {
                    delete e.roles;
                    delete e.locations;

                    return HamQuest.put(QuestRoute.settings.updateUser, e)
                        .then(() => getUserData())
                }}
                text='Update User'
                editable
            >
                <EmailInput />
                <Input
                    label='First Name'
                    name='firstName'
                    required
                />
                <Input
                    label='Last Name'
                    name='lastName'
                    required
                />
            </FormSetting>
        </PageBreak>
    );
}

export default Details;